<script setup>
import { ref, useSlots, watch } from "vue";

const props = defineProps({
    visible: {
        type: Boolean,
        default: false,
    },
    class: {
        type: String,
        default: "",
    },
    position: {
        type: Object,
        default() {
            return {                    
                bottom: 0,
                left: 0
            }
        }
    },
    transition: {
        type: String,
        default: "fade",
    },
});

const emit = defineEmits(["update:visible"]);
const el = ref("el");
const slots = useSlots();
const showModal = ref(props.visible);

const closeModal = () => {
    showModal.value = false;
    emit("update:visible", false);
};

const getPosition = () => {
    if (el.value !== "el") {
        const viewportWidth = window.innerWidth;
        const { width } = el.value.getBoundingClientRect();

        if (width + props.position.left > viewportWidth) {
            return `right: 10px; top: ${props.position.bottom}px;`;
        } else {
            return `left: ${props.position.left}px; top: ${props.position.bottom}px;`;
        }
    }
};

watch(
    () => props.visible,
    newVal => {
        showModal.value = newVal;
    }
);
</script>

<template lang="pug">
transition(:name="props.transition", ref="el")
    .qmodii-popover(v-show="showModal", :class="props.class" :style="getPosition()")
        .qmodii-popover-body
            slot
</template>

<style scoped lang="stylus">

.qmodii-popover
    position fixed
    width auto
    max-width 600px
    max-height 90%
    height fit-content
    background white
    border var(--qmodii-primary-border);
    border-radius 4px
    box-shadow 0 4px 6px rgba(0, 0, 0, 0.1)
    z-index 1000
    overflow auto

    .qmodii-popover-body
        display flex
        flex-direction column
        flex-grow 1

// Transition animations
.fade-enter-active
.fade-leave-active
    transition opacity 0.2s ease

.fade-enter-from
.fade-leave-to
    opacity 0

.slide-fade-enter-active
.slide-fade-leave-active
    transition all 0.3s ease

.slide-fade-enter-from
.slide-fade-leave-to
    opacity 0
    transform translateY(-20px)

.slide-enter-active
.slide-leave-active
    transition transform 0.3s ease

.slide-enter-from
.slide-leave-to
    transform translateY(-20px)
</style>
